module.exports = __webpack_public_path__ + "static/media/Restrictions_on_internal_movement_timeline.ce0bbf03.svg";